export const getDaysPast = (date: string) => {
  const oneDay = 24 * 60 * 60 * 1000;
  const current = new Date(date);
  const now = new Date();

  const period = Math.ceil(
    Math.abs(
      (Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) -
        Date.UTC(
          current.getFullYear(),
          current.getMonth(),
          current.getDate(),
        )) /
        oneDay,
    ),
  );

  if (period < 0) {
    return 0;
  }

  return period > 1 ? `${period} days` : `${period} day`;
};
